import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
require('../node_modules/bootstrap/dist/css/bootstrap.css')
// require('../node_modules/bootstrap-icons/dist/css/bootstrap.css')

createApp(App).use(store).use(router).mount('#app')
